module.exports = __webpack_public_path__ + "img/CM-JN-24-Hyundai-Playful.9b2ef196.jpg";